import React from "react";
import { Box, FormControlLabel, Checkbox } from "@mui/material";

const CheckboxFormSimple = ({
  orderFormFieldKey,
  orderFormFieldTouched,
  orderFormFieldError,
  nameText,
  value,
  setFieldValue,
  handleBlur,
}) => {
  return (
    <Box
      key={orderFormFieldKey}
      sx={{
        width: "100%",
      }}
    >
      <FormControlLabel
        control={
          <Checkbox
            id={orderFormFieldKey}
            name={orderFormFieldKey}
            checked={Boolean(value)}
            onChange={(e) => {
              setFieldValue(orderFormFieldKey, e.target.checked);
            }}
          />
        }
        label={nameText}
      />
    </Box>
  );
};

export default CheckboxFormSimple;
